import { dashboardImageConstants } from "../constants";

export function dashboardImage(state = {}, action) {
  switch (action.type) {
    case dashboardImageConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool,
      };
    case dashboardImageConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case dashboardImageConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.data,
        loading: false,
      };
    case dashboardImageConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    default:
      return state;
  }
}
